import Swiper from 'swiper';

/**
 * Update main carousel tab index
 *
 * @param {Swiper} swiper - Swiper instance
 * @param {string} classEl - target element
 * @param {boolean} tab - enable/disable tabbing
 * @returns {void} - side effect
 */
function updateCarouselTabIndex(swiper, classEl = '.swiper-slide-visible a', tab = true) {
    const getPrevVisibleSlides = Array.from(swiper.el.querySelectorAll('.updated'));
    const getCurrentVisibleSlides = Array.from(swiper.el.querySelectorAll(classEl));
    getPrevVisibleSlides.forEach(item => {
        item.setAttribute('aria-hidden', true);
        if (tab) {
            item.setAttribute('tabindex', '-1');
        }
        item.classList.remove('updated');
    });
    getCurrentVisibleSlides.forEach(item => {
        item.removeAttribute('aria-hidden');
        if (tab) {
            item.setAttribute('tabindex', '0');
        }
        item.classList.add('updated');
    });
}

export default updateCarouselTabIndex;
